export default __webpack_public_path__ + "static/media/referTenant.f2e2a2c8.svg";